/* eslint @stylistic/key-spacing: ["error", {  "align": "value" }]*/

const ROUTES = {
    HOME:                 'home',
    USERS:                'users',
    TICKETHOLDER:         'ticket-holder-page',
    PRODUCT:              'product-page',
    TICKETCREATION:       'ticket-creation',
    ACCOUNTING:           'accounting',
    APPLICATION_REQUESTS: 'application-requests'
}

export default ROUTES